var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7245 11.5082C20.7245 11.2472 20.6238 11.0265 20.4532 10.8555L12.6785 2.89008C12.4878 2.69937 12.2568 2.59865 12.0056 2.59865C11.7442 2.59865 11.4931 2.70922 11.3328 2.89994L3.54734 10.8555C3.46054 10.9405 3.3918 11.0422 3.34526 11.1544C3.29872 11.2667 3.27532 11.3872 3.27649 11.5087C3.27649 12.0307 3.67806 12.4224 4.20049 12.4224C4.44134 12.4224 4.68263 12.3221 4.8532 12.1609L12.0052 4.84865L19.1568 12.1614C19.3278 12.3221 19.5588 12.4228 19.8099 12.4228C20.3319 12.4228 20.7241 12.0307 20.7241 11.5087M20.7241 20.4787C20.7241 20.2275 20.6233 19.9965 20.4528 19.8259L12.6781 11.8704C12.4873 11.6797 12.2563 11.5789 12.0052 11.5789C11.7438 11.5789 11.4926 11.6797 11.3323 11.8704L3.54734 19.8255C3.37677 20.0064 3.27649 20.2271 3.27649 20.4782C3.27452 20.6001 3.29707 20.7211 3.34281 20.8341C3.38855 20.9471 3.45654 21.0498 3.54273 21.136C3.62893 21.2222 3.73158 21.2902 3.84457 21.3359C3.95756 21.3816 4.0786 21.4042 4.20049 21.4022C4.44134 21.4022 4.68263 21.2921 4.8532 21.1314L12.0052 13.8285L19.1568 21.1314C19.3278 21.2921 19.5588 21.4022 19.8099 21.4022C20.3319 21.4022 20.7241 21.0011 20.7241 20.4787Z",
    fill: "#CE202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.77cb6aaf9a5f29df80bea01193a7c177.svg";
export { ForwardRef as ReactComponent };